import { HttpClient } from '../../gateways'
import { UnexpectedError } from '../../models/errors'
import { setupIntranetV2ApiClient } from '../../proxies/apis/intranet-v2'
import { HttpStatusCode } from '../../types/gateways'

type ExportarRelatorioConsumoLancheInput = {
  params?: any
}

type ExportarRelatorioConsumoLancheOutput = {
  body?: Blob
  headers?: any
}

export const exportarRelatorioConsumoLanche = async (
  input?: ExportarRelatorioConsumoLancheInput
): Promise<ExportarRelatorioConsumoLancheOutput> => {
  const response = await HttpClient.of(setupIntranetV2ApiClient()).request({
    url: '/restaurante/relatorio-consumo-lanche/exportar',
    method: 'GET',
    params: input?.params,
    responseType: 'blob'
  })

  switch (response.statusCode) {
    case HttpStatusCode.ok:
      return {
        body: response.body,
        headers: response.headers
      }

    default:
      throw new UnexpectedError()
  }
}
